import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from '../../../api/services/auth.service';

@Component({
  selector: 'app-register-bar',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, RouterModule,
    MatCardModule, MatFormFieldModule, MatInputModule,
    MatButtonModule, MatIconModule, MatProgressSpinnerModule,
    MatSnackBarModule, MatStepperModule, MatDividerModule
  ],
  templateUrl: './register-bar.component.html'
})
export class RegisterBarComponent {
  ownerForm: FormGroup;
  barForm: FormGroup;
  paymentForm: FormGroup;

  loading = false;
  success = false;
  hidePassword = true;

  idFront: File | null = null;
  idBack: File | null = null;
  barDoc: File | null = null;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.ownerForm = this.fb.group({
      ownerFirstName: ['', Validators.required],
      ownerLastName:  ['', Validators.required],
      ownerEmail:     ['', [Validators.required, Validators.email]],
      ownerPassword:  ['', [Validators.required, Validators.minLength(8)]],
      ownerPhone:     ['', Validators.required]
    });

    this.barForm = this.fb.group({
      barName:      ['', Validators.required],
      description:  [''],
      licenseNumber:['', Validators.required],
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      city:         ['', Validators.required],
      state:        [''],
      country:      ['', Validators.required],
      postalCode:   [''],
      phone:        ['', Validators.required],
      contactEmail: ['', Validators.email],
      website:      ['']
    });

    this.paymentForm = this.fb.group({
      bankAccountNumber:  [''],
      mobileMoneyAccount: ['']
    });
  }

  onFileChange(event: Event, field: 'idFront' | 'idBack' | 'barDoc'): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this[field] = input.files[0];
    }
  }

  submit(): void {
    if (this.ownerForm.invalid || this.barForm.invalid) return;
    if (!this.idFront || !this.idBack || !this.barDoc) {
      this.snackBar.open('Please upload all required documents.', 'Close', { duration: 4000, panelClass: 'snack-error' });
      return;
    }

    this.loading = true;
    const data = { ...this.ownerForm.value, ...this.barForm.value, ...this.paymentForm.value };
    const formData = new FormData();
    formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
    formData.append('idFront', this.idFront);
    formData.append('idBack', this.idBack);
    formData.append('barDoc', this.barDoc);

    this.auth.registerBar(formData).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.success = true;
        this.snackBar.open(
          res.message || 'Registration submitted! Your documents are under review.',
          'OK', { duration: 8000 }
        );
        setTimeout(() => this.router.navigate(['/login']), 3000);
      },
      error: (err) => {
        this.loading = false;
        const msg = err.error?.error || err.error?.message || 'Registration failed. Please try again.';
        this.snackBar.open(msg, 'Close', { duration: 5000, panelClass: 'snack-error' });
      }
    });
  }
}
